import { ADD_BOOK, DELETE_BOOK, UPDATE_BOOK, SHOW_BOOKS, CHANGE_OPERATION, SELECT_CANDIDATE } from "./actionsTypes";

const initialState = { operation: "create", books: [], candidate: {} };

const booksReducer = (state = initialState, action) => {
  switch (action.type) {
    case SHOW_BOOKS: {
      const books = action.payload;
      const previousState = structuredClone(state);

      return { ...previousState, books };
    }

    case ADD_BOOK: {
      const newBook = action.payload;
      const previousState = structuredClone(state);

      const updatedBooks = [...previousState.books, newBook];

      return { ...previousState, books: updatedBooks };
    }

    case UPDATE_BOOK: {
      const updatedBook = action.payload;
      const previousState = structuredClone(state);

      const updatedBooks = previousState.books.map((book) => book.id === updatedBook.id ? updatedBook : book);

      return { ...previousState, books: updatedBooks };
    }

    case DELETE_BOOK: {
      const bookID = action.payload;
      const previousState = structuredClone(state);

      const updatedBooks = previousState.books.filter((book) => book.id !== bookID);

      return { ...previousState, books: updatedBooks };
    }

    case CHANGE_OPERATION: {
      const operation = action.payload;
      const previousState = structuredClone(state);

      return { ...previousState, operation };
    }

    case SELECT_CANDIDATE: {
      const candidate = action.payload;
      const previousState = structuredClone(state);

      return { ...previousState, candidate };
    }

    default:
      return state;
  }
};

export default booksReducer;
